<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configuration-target-va-optimization">
    <div class="title-btns-section"> 
      <div class="title">Virtual Agent Analytics Targets</div>
      <div class="update-btns">
        <!-- <div class="update-cancel-btn" @click="controller.appVue.handleAppModalClose">Cancel</div> -->
        <button :class="(isDisabled?'update-save-btn disabled':'update-save-btn')" :disabled="isDisabled" @click="updateTargets">Update</button>
      </div>
    </div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick" :before-leave="beforeLeave" v-loading="loading">
        <el-tab-pane v-if="isRoleAllow([4101, 900002])&&!this.hiddenTabes.includes('wy-va-optimization-overview-chart-panel')" ref="overviewTab" label="Overview" name="overview">
          <div class="search-section">
            <div class="keyword-input">
              <el-input
                ref="searchTargets"
                class="search-targets"
                placeholder="Search metrics"
                v-model="searchKeywordInput.value"
              ></el-input>
              <i v-if="searchKeywordInput.value!=''" class="fas fa-times-circle" @click="clearSearchInput(searchKeywordInput)"></i>
            </div>
            <div v-if="$refs.targetOverviewTable && $refs.targetOverviewTable.tableData" class="btn-section" :class="{'disabled':($refs.targetOverviewTable.tableData.length==0)}">
              <div class="clear-all-btn" @click="handleClearAllTargets(optimizationOverviewTargetData)"><span>Clear all targets</span></div>
              <div class="reset-all-btn" @click="handleDiscardUnsavedChanges"><span>Discard unsaved changes</span></div>
            </div>
          </div>
          <div class="content-section"> 
            <wy-table-list ref="targetOverviewTable" :controller="module" :configrationData="optimizationOverviewTargetData" :configrationColumns="overviewTableColumns" :searchKeywordInput="searchKeywordInput.value" :enableSelection="true" :mode="'generic'" />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="isRoleAllow([4111, 900002])" label="Performance Comparison " ref="performanceComparisonTab" name="performanceComparison">
          <div class="search-section">
            <div class="keyword-input">
              <el-input
                ref="searchTargets"
                class="search-targets"
                placeholder="Search metrics"
                v-model="searchComparisonKeywordInput.value"
              ></el-input>
              <i v-if="searchComparisonKeywordInput.value!=''" class="fas fa-times-circle" @click="clearSearchInput(searchComparisonKeywordInput)"></i>
            </div>
            
            <div v-if="$refs.targetComparisonTable && $refs.targetComparisonTable.tableData" class="btn-section" :class="{'disabled':($refs.targetComparisonTable.tableData.length == 0)}">
              <div class="clear-all-btn" @click="handleClearAllTargets(optimizationComparisonTargetData)"><span>Clear all targets</span></div>
              <div class="reset-all-btn" @click="handleDiscardUnsavedChanges"><span>Discard unsaved changes</span></div>
            </div>
          </div>
          <div class="content-section"> 
            <wy-table-list ref="targetComparisonTable" v-if="optimizationComparisonTargetData" :controller="module" :configrationData="optimizationComparisonTargetData" :configrationColumns="comparisonTableColumns" :searchKeywordInput="searchComparisonKeywordInput.value" :enableSelection="true" :mode="'generic'" />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="isRoleAllow([4121, 900002])&&!this.hiddenTabes.includes('wy-va-optimization-response-performance-chart-panel')" label="Response Performance" name="responsePerformance">
          <div class="search-section">
            <div class="keyword-input">
              <el-input
                ref="searchTargets"
                class="search-targets"
                placeholder="Search metrics"
                v-model="searchResponsePerformanceKeywordInput.value"
              ></el-input>
              <i v-if="searchResponsePerformanceKeywordInput.value!=''" class="fas fa-times-circle" @click="clearSearchInput(searchResponsePerformanceKeywordInput)"></i>
            </div>
            <div v-if="$refs.targetResponsePerformanceTable && $refs.targetResponsePerformanceTable.tableData" class="btn-section" :class="{'disabled':($refs.targetResponsePerformanceTable.tableData.length==0)}">
              <div class="clear-all-btn" @click="handleClearAllTargets(optimizationResponsePerformanceTargetData)"><span>Clear all targets</span></div>
              <div class="reset-all-btn" @click="handleDiscardUnsavedChanges"><span>Discard unsaved changes</span></div>
            </div>
          </div>
          <div class="content-section"> 
            <wy-table-list ref="targetResponsePerformanceTable" :controller="module" :configrationData="optimizationResponsePerformanceTargetData" :configrationColumns="responsePerformanceTableColumns" :searchKeywordInput="searchResponsePerformanceKeywordInput.value" :enableSelection="true" :mode="'generic'" />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="false" label="Journey Performance" name="journeyPerformance" :disabled="true">
        </el-tab-pane>
        <el-tab-pane v-if="isRoleAllow([4141, 900002])&&!this.hiddenTabes.includes('wy-va-optimization-intent-performance-chart-panel')" label="Intent Performance" name="nluIntentPerformance">
          <div class="search-section">
            <div class="keyword-input">
              <el-input
                ref="searchTargets"
                class="search-targets"
                placeholder="Search metrics"
                v-model="searchNluIntentPerformanceKeywordInput.value"
              ></el-input>
              <i v-if="searchNluIntentPerformanceKeywordInput.value!=''" class="fas fa-times-circle" @click="clearSearchInput(searchNluIntentPerformanceKeywordInput)"></i>
            </div>
            <div v-if="$refs.targetNluIntentPerformanceTable && $refs.targetNluIntentPerformanceTable.tableData" class="btn-section" :class="{'disabled':($refs.targetNluIntentPerformanceTable.tableData.length==0)}">
              <div class="clear-all-btn" @click="handleClearAllTargets(optimizationNluIntentPerformanceTargetData)"><span>Clear all targets</span></div>
              <div class="reset-all-btn" @click="handleDiscardUnsavedChanges"><span>Discard unsaved changes</span></div>
            </div>
          </div>
          <div class="content-section"> 
            <wy-table-list ref="targetNluIntentPerformanceTable" :controller="module" :configrationData="optimizationNluIntentPerformanceTargetData" :configrationColumns="nluIntentPerformanceTableColumns" :searchKeywordInput="searchNluIntentPerformanceKeywordInput.value" :enableSelection="true" :mode="'generic'" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import WyTableList from '../../widgets/wy-table-list-targets';
  // import WyDialog from '../../widgets/wy-dialog.vue'
  import WyVaOptimizationUtils from '../../optimization/utils/wy-va-optimization-utils.js';
  import WyAnalyticsConfigurationUtils from "./utils/wy-configration-utils"

  export default {
    name: 'wy-configuration-target-va-optimization',
    components: { 
      'wy-table-list': WyTableList,
      // 'wy-dialog': WyDialog
    },
    props: ['controller'],
    
    data() {
      return {
        module: this,
        loading: false,
        currentTab: 'overview',
        searchKeywordInput: {value: ''},
        searchComparisonKeywordInput: {value: ''},
        searchResponsePerformanceKeywordInput: {value: ''},
        searchNluIntentPerformanceKeywordInput: {value: ''},
        searchKeyword: '',
        activeName: 'first',
        tableColumns: [],
        hiddenTabes: [],
        overviewTableColumns: [
          {label: "Metric name", name: "name", mandatory: true, selected: true, sortable: true, group: 'Name', align:"left", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
          {label: "Target", name: "target", type: "targetWithReverse", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
        ],
        comparisonTableColumns: [
          {label: "Metric Name", name: "name", mandatory: true, selected: true, sortable: true, group: 'Name', align:"left", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
          {label: "Total Target", name: "total", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Total Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Language Target", name: "lang", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Language Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Channel Target", name: "channel", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Channel Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Daily Target", name: "day", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Daily Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Monthly Target", name: "month", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Monthly Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Quarterly Target", name: "quarter", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Quarterly Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Yearly Target", name: "year", type: "targetWithOperator", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Yearly Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
        ],
        
        responsePerformanceTableColumns: [
          {label: "Metric Name", name: "name", mandatory: true, selected: true, sortable: true, group: 'Name', align:"left", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
          {label: "Target", name: "target", type: "targetWithReverse", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
        ],
        nluIntentPerformanceTableColumns: [
          {label: "Metric Name", name: "name", mandatory: true, selected: true, sortable: true, group: 'Name', align:"left", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
          {label: "Target", name: "target", type: "targetWithReverse", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Target', cssClass: 'target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
        ],
        originCompanySettingData: null,
        companyProfileSettingsLocal: {},
        optimizationOverviewTargetData: {},
        optimizationOverviewTargetDataClone: {},

        optimizationResponsePerformanceTargetData: {},
        optimizationResponsePerformanceTargetDataClone: {},

        optimizationNluIntentPerformanceTargetData:{},
        optimizationNluIntentPerformanceTargetDataClone:{},

        optimizationComparisonTargetData: {},
        optimizationComparisonTargetDataClone: {},

        optimizationComparisonTarget: [],
        localTableFieldsMap: {},
        disableSection: false
      };
    },

    computed: {
      ...mapGetters(['dataModel', 'currentPageInfo', 'isRoleAllow', 'companyProfileSettings', 'companyConfig', 'config']),

      isDisabled() {
        return this.controller.hasError || !this.controller.hasNoSavedChanges
      }
    },

    watch: {
      optimizationOverviewTargetData: {
          handler: function(newValue) {
            this.compareDifference(newValue, this.optimizationOverviewTargetDataClone)
          },
          deep: true
      },
      optimizationResponsePerformanceTargetData: {
          handler: function(newValue) {
            this.compareDifference(newValue, this.optimizationResponsePerformanceTargetDataClone)
          },
          deep: true
      },
      optimizationNluIntentPerformanceTargetData: {
          handler: function(newValue) {
            this.compareDifference(newValue, this.optimizationNluIntentPerformanceTargetDataClone)
          },
          deep: true
      },
      optimizationComparisonTargetData: {
          handler: function(newValue) {
            this.compareDifferenceWithDynamicFields(newValue, this.optimizationComparisonTargetDataClone);
          },
          deep: true
      }
    },

    methods: {
      ...mapMutations(['updateDataModelColumns']),
      ...mapActions(["updateCompanyProfileSettings"]),

      clearSearchInput(obj) {
        obj.value = '';
      },
      handleDiscardUnsavedChanges() {
        if(!this.originCompanySettingData || !this.originCompanySettingData.targetSettings) {
          this.companyProfileSettings.targetSettings = null
        }
        else {
          this.companyProfileSettings.targetSettings = this.originCompanySettingData.targetSettings
        }
        this.prepareData();
        if(this.$refs.targetOverviewTable) this.$refs.targetOverviewTable.contactReasonsData = this.optimizationOverviewTargetData;
        if(this.$refs.targetComparisonTable) {
          this.$refs.targetComparisonTable.contactReasonsData = this.optimizationComparisonTargetData;
          this.loading = true;
          this.$refs.targetComparisonTable.refreshTable();
        }
        if(this.$refs.targetResponsePerformanceTable) this.$refs.targetResponsePerformanceTable.contactReasonsData = this.optimizationResponsePerformanceTargetData;
        if(this.$refs.targetNluIntentPerformanceTable) this.$refs.targetNluIntentPerformanceTable.contactReasonsData = this.optimizationNluIntentPerformanceTargetData;
        this.controller.hasNoSavedChanges = false;
        this.controller.hasError = false;
      },

      handleClearAllTargets(data) {
        this.controller.hasError = false;
        data.data.forEach(item => {
          if(item.target && item.target.operator && item.operator != '-') {
            item.target.operator = '-'
            this.controller.hasNoSavedChanges = true;
          }
          if(item.target && item.target.value) {
            item.target.value = null;
            if(item.target.reverse) item.target.reverse = false;
            this.controller.hasNoSavedChanges = true;
          }
          else {
            if(Object.keys(item).length > 0) {
              Object.keys(item).forEach(key => {
                if(item[key].value) {
                  item[key].value = null;
                  this.controller.hasNoSavedChanges = true;
                }
                if(item[key].operator && item[key].operator != '-') {
                  item[key].operator = '-'
                  this.controller.hasNoSavedChanges = true;
                }
              })
            }
          }
        })
      },

      compareDifference(newValue, oldValue) {
        newValue.data.forEach(item => {
          if(typeof item.target.value != 'undefined'){
            if(item.target.value) {
              // item.target.value = item.target.value
            }
            else if(item.target.value=='') {
              item.target.value = null
            }
          } 
        })
        if(JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          this.controller.hasNoSavedChanges = false;
        }
        else {
          this.controller.hasNoSavedChanges = true;
        }
      },

      compareDifferenceWithDynamicFields(newValue, oldValue) {
        if(newValue.data) {
          newValue.data.forEach(item => {
            Object.keys(item).forEach(key => {
              if(Object.keys(item[key]).length > 0) {
                if(typeof item[key].value != 'undefined'){
                  if(item[key].value) {
                    // item[key].value = item[key].value
                  }
                  else if(item[key].value=='') {
                    item[key].value = null;
                  }
                } 
              }
            })
          })
          setTimeout(()=>{
            if(JSON.stringify(newValue) === JSON.stringify(oldValue)) {
              this.controller.hasNoSavedChanges = false;
            }
            else {
              this.controller.hasNoSavedChanges = true;
            }
            if(typeof this.controller.hasError != 'undefined') {
              this.controller.hasError = document.querySelectorAll('.has-error').length > 0;
            }
          }, 200)
        }
      },

      beforeLeave(newTab) {
        if(this.controller.hasNoSavedChanges) {
          this.handleSaveUnchanges(newTab);
          return false
        }
      },
      handleSaveUnchanges(newTab, handleAppModalClose, fromMainTab) {
        this.controller.$refs.updateDialog.title = `Review changes`;
        this.controller.$refs.updateDialog.content="There are unsaved changes. Do you want to discard or save them before leaving?" 
        this.controller.$refs.updateDialog.open();
        if(typeof this.controller.hasError != 'undefined' && !this.controller.hasError) {
          this.controller.hasError = document.querySelectorAll('.has-error').length > 0;
        }
        if(this.controller.hasError) {
          this.controller.$refs.updateDialog.disableSaveBtn = true;
        }
        else {
          this.controller.$refs.updateDialog.disableSaveBtn = false;
        }
        this.controller.$refs.updateDialog.confirmButtonCallback = async () => {
          this.updateTargets()
          this.controller.hasNoSavedChanges = false;
          if(fromMainTab) {
            if(handleAppModalClose) {
              handleAppModalClose();
            }
            else {
              this.controller.handleTabClick({name: newTab})
              this.controller.activeTab = newTab
            }
          }
          else {
            if(handleAppModalClose) {
              handleAppModalClose();
            }
            else {
              this.activeName = newTab
            }
          }
        }
        this.controller.$refs.updateDialog.discardButtonCallback = async () => {
          this.handleDiscardUnsavedChanges();
          if(fromMainTab) {
            if(handleAppModalClose) {
              handleAppModalClose();
            }
            else {
              this.controller.handleTabClick({name: newTab})
              this.controller.activeTab = newTab
            }
          }
          else {
            if(handleAppModalClose) {
              handleAppModalClose();
            }
            else {
              this.activeName = newTab
            }
          }
        }
      },
      handleTabClick(tab) {
        if(tab.name == 'overview') {
          if(this.currentTab != 'overview') {
            this.loading = true;
            this.tableColumns = this.overviewTableColumns
            this.$refs.targetOverviewTable.refreshTable();
            this.disableSection = (this.$refs.targetOverviewTable.tableData.length == 0) ? true : false;
            this.currentTab = 'overview'
          }
        }
        if(tab.name == 'performanceComparison') {
          if(this.currentTab != 'performanceComparison') {
            this.loading = true;
            this.tableColumns = this.comparisonTableColumns
            this.$refs.targetComparisonTable.refreshTable();
            this.disableSection = (this.$refs.targetComparisonTable.tableData.length == 0) ? true : false;
            this.currentTab = 'performanceComparison'
          }
        }
        if(tab.name == 'responsePerformance') {
          if(this.currentTab != 'responsePerformance') {
            this.loading = true;
            this.tableColumns = this.responsePerformanceTableColumns
            this.$refs.targetResponsePerformanceTable.refreshTable();
            this.disableSection = (this.$refs.targetResponsePerformanceTable.tableData.length == 0) ? true : false;
            this.currentTab = 'responsePerformance'
          }
        }
        if(tab.name == 'nluIntentPerformance') {
          if(this.currentTab != 'nluIntentPerformance') {
            this.loading = true;
            this.tableColumns = this.nluIntentPerformanceTableColumns
            this.$refs.targetNluIntentPerformanceTable.refreshTable();
            this.disableSection = (this.$refs.targetNluIntentPerformanceTable.tableData.length == 0) ? true : false;
            this.currentTab = 'nluIntentPerformance'
          }
        }
      },
      checkSettingsActived(data) {
        let cloneData = JSON.parse(JSON.stringify(data))
        let list = [];
        cloneData.forEach(item => {
          if(item.target.value) {
            item.target.value = Number(item.target.value)
            list.push(item);
          }
        })
        return list
      },
      checkComparisonSettingsActived(data) {
        let cloneData = JSON.parse(JSON.stringify(data))
        let list = [];
        cloneData.forEach(item => {
          let isActived = false;
          Object.keys(item).forEach(key => {
            if(Object.keys(item[key]).length > 0) {
              if(item[key].value) {
                item[key].value = Number(item[key].value);
                isActived = true;
              }
            }
          })
          if(isActived) {
            list.push(item);
          }
        })
        return list;
      },

      // checkNested(obj) {
      //   var args = Array.prototype.slice.call(arguments, 1);
      //   for (var i = 0; i < args.length; i++) {
      //     if (!obj || !obj.hasOwnProperty(args[i].key)) {
      //       if(args[i].type == 'Object') obj[args[i].key] = {};
      //       if(args[i].type == 'Array') obj[args[i].key] = [];
      //     }
      //     obj = obj[args[i].key];
      //   }
      //   return obj;
      // },

      updateTargets() {
        if(!this.companyProfileSettings) {
          this.companyProfileSettings = {}
        }
        WyAnalyticsConfigurationUtils.checkNested(this.companyProfileSettings, {key: 'targetSettings', type: 'Object'}, {key: 'settings', type: 'Object'}, {key: 'optimization', type: 'Object'});
        this.companyProfileSettingsLocal = this.companyProfileSettings.targetSettings.settings;

        let overviewUpdateData = this.checkSettingsActived(this.optimizationOverviewTargetData.data)
        this.companyProfileSettingsLocal.optimization.overviewTarget = overviewUpdateData;
        let responsePerformanceUpdateData = this.checkSettingsActived(this.optimizationResponsePerformanceTargetData.data)
        this.companyProfileSettingsLocal.optimization.responsePerformanceTarget = responsePerformanceUpdateData;
        let nluIntentPerformanceUpdateData = this.checkSettingsActived(this.optimizationNluIntentPerformanceTargetData.data)
        this.companyProfileSettingsLocal.optimization.nluIntentPerformanceTarget = nluIntentPerformanceUpdateData;

        let updateData = this.checkComparisonSettingsActived(this.optimizationComparisonTargetData.data)
        this.companyProfileSettingsLocal.optimization.comparisonTarget = updateData;
        let success = this.updateCompanyProfileSettings(this.companyProfileSettingsLocal);
        if(success) {
          this.controller.hasNoSavedChanges = false;
          this.optimizationOverviewTargetDataClone = JSON.parse(JSON.stringify(this.optimizationOverviewTargetData))
          this.optimizationResponsePerformanceTargetDataClone = JSON.parse(JSON.stringify(this.optimizationResponsePerformanceTargetData))
          this.optimizationNluIntentPerformanceTargetDataClone = JSON.parse(JSON.stringify(this.optimizationNluIntentPerformanceTargetData))
          this.optimizationComparisonTargetDataClone = JSON.parse(JSON.stringify(this.optimizationComparisonTargetData))
          
          this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateSuccess"),
            customClass: 'configuration-success-message',
            type: 'success'
          });
        }
        else {
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateFailed"),
            customClass: 'configuration-failed-message',
            type: 'error'
          });
        }
      },

      mappingComparisonData(key) {
        let label = null;
        let tableNames = Object.keys(this.localTableFieldsMap);
        tableNames.forEach(tableName => {
          let tableFieldsMap = this.localTableFieldsMap[tableName];
          if(tableFieldsMap[key]) {
            label = tableFieldsMap[key]
          }
        })
        return label;
      },

      prepareData() {
        let optimizationOverviewTarget = [];
        let optimizationResponsePerformanceTarget = [];
        let optimizationNluIntentPerformanceTarget = [];
        let optimizationComparisonTarget = [];
        this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings))
        if(this.companyProfileSettings&&this.companyProfileSettings.targetSettings&&this.companyProfileSettings.targetSettings.settings&&this.companyProfileSettings.targetSettings.settings.optimization) {
          optimizationOverviewTarget = (this.companyProfileSettings&&this.companyProfileSettings.targetSettings)?this.companyProfileSettings.targetSettings.settings.optimization.overviewTarget:[]; //WyAnalyticsConfigurationUtils.getOverviewTargetMockData();
          optimizationResponsePerformanceTarget =  this.companyProfileSettings.targetSettings.settings.optimization.responsePerformanceTarget; //WyAnalyticsConfigurationUtils.getResponsePerformanceTargetMockData();
          optimizationNluIntentPerformanceTarget =  this.companyProfileSettings.targetSettings.settings.optimization.nluIntentPerformanceTarget; //WyAnalyticsConfigurationUtils.getNluIntentPerformanceTargetMockData();
          optimizationComparisonTarget = this.companyProfileSettings.targetSettings.settings.optimization.comparisonTarget; //WyAnalyticsConfigurationUtils.getComparisonTargetMockData();
        }

        let comparisonList = []
        let columns = ['total', 'lang', 'channel', 'year', 'quarter', 'month', 'day'];
        let numberSuffixMap = {
          'numOfSessions': 'number',
          'numOfConversations': 'number',
          'numberOfCustomerMessages': 'number',
          'numberOfBotResponses': 'number',
          'numberOfIntents': 'number',
          'numberOfUtterances': 'number',
          'numberOfUtterancesWithoutWildcards': 'number',
          'numberOfWildcardUtterances': 'number',
        }

        let vaoOverViewPageMetrics = this.companyConfig ? (((this.companyConfig.appPages || {}).vaoOverViewPage || {}).metrics || {}) : {};
        let tableFieldsMap = WyVaOptimizationUtils.tablesMap;
        this.localTableFieldsMap = JSON.parse(JSON.stringify(tableFieldsMap))
        Object.keys(WyVaOptimizationUtils.tablesMap).forEach(key => {
          Object.keys(WyVaOptimizationUtils.tablesMap[key]).forEach(itemKey => {
            if((vaoOverViewPageMetrics[itemKey]!==undefined && vaoOverViewPageMetrics[itemKey] === false)) {
              delete this.localTableFieldsMap[key][itemKey]
            }
          })
        })
        let persentageSuffixList = ['negativeFeedbackRate', 'understandingTotal']
        Object.keys(this.localTableFieldsMap).forEach(key => {
          Object.keys(this.localTableFieldsMap[key]).forEach(itemKey => {
            let obj = {};
            obj.key = itemKey;
            obj.name = this.localTableFieldsMap[key][itemKey];
            obj.actived = false;
            columns.forEach(columnsKey => {
              obj[columnsKey] = {
                value: null,
                operator: '-',
                prefix: '',
                suffix: '',
                enabled: false
              }
              if(!numberSuffixMap[itemKey]) {
                obj[columnsKey].suffix = '%';
              }
            })
            optimizationComparisonTarget.forEach(item => {
              if(item.key == itemKey) {
                columns.forEach(key => {
                  obj[key] = item[key]
                  if(item[key].value != null) {
                    obj[key].value = item[key].value.toString()
                  }
                })
              }
            })
            comparisonList.push(obj)
          })
        })
        let pieChartOverviewMap = this.filterTableMap(WyVaOptimizationUtils.pieChartOverviewMap, 'vaoOverViewPage');
        let overviewList = [];
        Object.keys(pieChartOverviewMap).forEach(key => {
          let obj = {};
          obj.key = key;
          obj.name = pieChartOverviewMap[key];
          obj.actived = false;
          obj.target = {
            value: null,
            suffix: '',
            reverse: false
          }
          if(persentageSuffixList.includes(key)) {
            obj.target.suffix = '%';
          }
          optimizationOverviewTarget.forEach(item => {
            if(item.key == key) {
              obj = item;
              if(item.target.value != null) {
                obj.target.value = item.target.value.toString()
              }
            }
          })
          overviewList.push(obj)
        })

        let pieChartResponsePerformanceMap = this.filterTableMap(WyVaOptimizationUtils.pieChartResponsePerformanceMap, 'responsePerformancePage');
        let optimizationResponsePerformanceList = [];
        Object.keys(pieChartResponsePerformanceMap).forEach(key => {
          let obj = {};
          obj.key = key;
          obj.name = pieChartResponsePerformanceMap[key];
          obj.actived = false;
          obj.target = {
            value: null,
            suffix: '',
            reverse: false
          }
          if(persentageSuffixList.includes(key)) {
            obj.target.suffix = '%';
          }
          optimizationResponsePerformanceTarget.forEach(item => {
            if(item.key == key) {
              obj = item;
              if(item.target.value != null) {
                obj.target.value = item.target.value.toString()
              }
            }
          })
          optimizationResponsePerformanceList.push(obj)
        })

        let pieChartNluIntentPerformanceMap = this.filterTableMap(WyVaOptimizationUtils.pieChartNluIntentPerformanceMap, 'nluIntentPerformancePage');
        let optimizationNluIntentPerformanceList = [];
        Object.keys(pieChartNluIntentPerformanceMap).forEach(key => {
          let obj = {};
          obj.key = key;
          obj.name = pieChartNluIntentPerformanceMap[key];
          obj.actived = false;
          obj.target = {
            value: null,
            suffix: '',
            reverse: false
          }
          if(persentageSuffixList.includes(key)) {
            obj.target.suffix = '%';
          }
          optimizationNluIntentPerformanceTarget.forEach(item => {
            if(item.key == key) {
              obj = item;
              if(item.target.value != null) {
                obj.target.value = item.target.value.toString()
              }
            }
          })
          optimizationNluIntentPerformanceList.push(obj)
        })
        this.optimizationComparisonTargetData = {
          data: comparisonList,
          targetType: 'withOperator'
        };
        this.optimizationComparisonTargetDataClone = JSON.parse(JSON.stringify(this.optimizationComparisonTargetData))

        this.optimizationOverviewTargetData = {
          data: overviewList,
          targetType: 'withReverse'
        };
        this.optimizationOverviewTargetDataClone = JSON.parse(JSON.stringify(this.optimizationOverviewTargetData))
        
        this.optimizationResponsePerformanceTargetData = {
          data: optimizationResponsePerformanceList,
          targetType: 'withReverse'
        }
        this.optimizationResponsePerformanceTargetDataClone = JSON.parse(JSON.stringify(this.optimizationResponsePerformanceTargetData))

        this.optimizationNluIntentPerformanceTargetData = {
          data: optimizationNluIntentPerformanceList,
          targetType: 'withReverse'
        }
        this.optimizationNluIntentPerformanceTargetDataClone = JSON.parse(JSON.stringify(this.optimizationNluIntentPerformanceTargetData))

        if(this.$refs.targetOverviewTable) this.$refs.targetOverviewTable.contactReasonsData = this.optimizationOverviewTargetData;
        if(this.$refs.targetComparisonTable) this.$refs.targetComparisonTable.contactReasonsData = this.optimizationComparisonTargetData;
        if(this.$refs.targetResponsePerformanceTable) this.$refs.targetResponsePerformanceTable.contactReasonsData = this.optimizationResponsePerformanceTargetData;
        if(this.$refs.targetNluIntentPerformanceTable) this.$refs.targetNluIntentPerformanceTable.contactReasonsData = this.optimizationNluIntentPerformanceTargetData;
      },

      filterTableMap(tableFieldsMap, pageName) {
        let vaoOverViewPageMetrics = this.companyConfig ? (((this.companyConfig.appPages || {})[pageName] || {}).metrics || {}) : {};
        let localTableFieldsMap = JSON.parse(JSON.stringify(tableFieldsMap))
        Object.keys(localTableFieldsMap).forEach(key => {
          if((vaoOverViewPageMetrics[key]!==undefined && vaoOverViewPageMetrics[key] === false)) {
            delete localTableFieldsMap[key]
          }
        })
        return localTableFieldsMap
      }
    },
    mounted() {
      if(this.isRoleAllow([4101, 900002])) {
        this.currentTab = "overview";
      }
      else if(this.isRoleAllow([4111, 900002])) {
        this.currentTab = "performanceComparison";
      }
      else if(this.isRoleAllow([4121, 900002])) {
        this.currentTab = "responsePerformance"
      }
      else if(this.isRoleAllow([4141, 900002])) {
        this.currentTab = "nluIntentPerformance"
      }
      this.handleTabClick({name: this.currentTab})

      if(this.companyConfig){
        this.companyConfig.appPanels.forEach(el => {
          if(el.enabled == false) {
            this.hiddenTabes.push(el.key)
          }
        })
        //For OC-1235 Hide tab by checking the metrics under appPages
        if(this.companyConfig.appPages && this.companyConfig.appPages.responsePerformancePage && this.companyConfig.appPages.responsePerformancePage.metrics) {
          let metrics = Object.keys(this.companyConfig.appPages.responsePerformancePage.metrics);
          if(metrics.length > 0) {
            let hasActiveMetrics = false;
            metrics.forEach(key => {
              if(this.companyConfig.appPages.responsePerformancePage.metrics[key]) {
                hasActiveMetrics = true
              }
            })
            if(!hasActiveMetrics) {
              if(!this.hiddenTabes.includes('wy-va-optimization-response-performance-chart-panel')) {
                this.hiddenTabes.push('wy-va-optimization-response-performance-chart-panel');
              }
            }
          }
        }
        if(this.companyConfig.appPages && this.companyConfig.appPages.nluIntentPerformancePage && this.companyConfig.appPages.nluIntentPerformancePage.metrics) {
          let metrics = Object.keys(this.companyConfig.appPages.nluIntentPerformancePage.metrics);
          if(metrics.length > 0) {
            let hasActiveMetrics = false;
            metrics.forEach(key => {
              if(this.companyConfig.appPages.nluIntentPerformancePage.metrics[key]) {
                hasActiveMetrics = true
              }
            })
            if(!hasActiveMetrics) {
              if(!this.hiddenTabes.includes('wy-va-optimization-intent-performance-chart-panel')) {
                this.hiddenTabes.push('wy-va-optimization-intent-performance-chart-panel');
              }
            }
          }
        }
      }
    }
  };
</script>

<style lang="scss">
  .wy-configuration-target-va-optimization {
    .wy-table-list .wy-table-wrapper {
      border-radius: 0px !important;
    }
    .wy-table-list .wy-table-fixed tbody {
      tr td:first-child {
        background-color: #FFFF;
      }
    }
    .wy-table-list.targets .wy-table-fixed thead th:nth-last-child(1) {
      border-bottom: 0px;
      padding-right: 0px;
    }
    
    .wy-table-list .wy-table-wrapper .wy-table-main {
      // height: calc(100vh - 515px);
      border-right: 1px solid #CAD2DA;
      border-bottom: 1px solid #cad2da;
    }
    .wy-table-list thead {
      background-color: #FFF;
      border: 1px solid #CAD2DA;
      border-left: 0px;
      border-right: 0px;
    }
    .wy-table-main thead tr {
      width: calc( 100vw - 686px);
      border-right: 1px solid #CAD2DA;
    }
    .wy-table-main thead th {
      background-color: #FFF;
    }
    .wy-table-list.targets .wy-table-main thead {
      width: calc(100% - 2px);
      th.wy-table-tail {
        display: none;
      }
    }

    .wy-table-list.targets .wy-table-fixed {
      border-left: 1px solid #CAD2DA;
    }
    
    .wy-table-list .wy-table-main tbody tr {
      width: calc(100% - 2px);
      border-right: 0px solid #CAD2DA;
      td {
        border-bottom: 0px solid #CAD2DA;
      }
    }
    .wy-table-list .wy-table-main tbody {
      height: calc(100vh - 415px) !important;
      max-height: unset !important;
      tr:last-child {
        td {
          border-bottom: 0px solid #CAD2DA;
        }
      }
    }
    .wy-table-main  {
      thead .wy-sub-header th.lastChild {
        text-align: left;
        
      }
      thead tr.wy-sub-header > th:first-child {
        border-left: 1px solid #CAD2DA;
      }
      thead .wy-sub-header th.lastChild:nth-child(2) {
        padding-left: 14px;
      }
      tbody tr td div {
        justify-content: left;
      }
    }
    
    .wy-table-list.targets .wy-table-main tbody {
      border-right: 0px;
      width: calc(100% - 4px);
      border-right: 1px solid #CAD2DA;
      border-bottom: 1px solid #eee;
      border-left: 1px solid #CAD2DA;
      // border-bottom: 1px solid #CAD2DA;
    }
    .wy-table-list.targets .wy-table-main thead th {
      background-color: #FFF;
    }
    .wy-table-list.targets thead tr th {
      color: var(--site-font-secondary-color);
    }
    .wy-table-list tbody tr td {
      border-bottom: 0px solid #CAD2DA;
    }
    .wy-table-list tbody tr td.last-child {
      border-right: 0px solid transparent;
    }
    .wy-table-list .wy-table-tail {
      width: 100%;
    }
    input[type="checkbox"] {
      accent-color: var(--primary-checkbox-button-check-color);
    }
    #pane-overview {
      .wy-table-wrapper {
        width: calc(100%) !important;
        // height: calc(100vh - 514px) !important;
        // border-right: 1px solid #CAD2DA;
        // border-bottom: 1px solid #cad2da;
      }
      .wy-table-list.targets .wy-table-main thead {
        width: calc(100% - 0px);
      }
      .wy-table-list.targets .wy-table-main tbody {
        border-right: 0px;
        width: calc(100%);
        border-right: 1px solid #CAD2DA;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #CAD2DA;
        // border-bottom: 1px solid #CAD2DA;
      }
      .wy-table-main thead tr {
        // width: calc( 100vw - 687px);
        width: calc(100vw - 771px);
        border-right: 1px solid #CAD2DA;
        border-bottom: 0px;
      }
    }
    #pane-performanceComparison {
      .wy-table-wrapper {
        width: calc(100%);
        // height: calc(100vh - 514px) !important;
        // border-right: 1px solid #CAD2DA;
        // border-bottom: 1px solid #cad2da;
      }
      .wy-table-list.targets .wy-table-main tbody {
        border-right: 0px;
        width: calc(100%);
        border-right: 1px solid #CAD2DA;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #CAD2DA;
        border-bottom: 1px solid #CAD2DA;
      }
      .wy-table-list.targets .wy-table-main {
        width: calc(100vw - 411px);
      }
      .wy-table-main thead .wy-sub-header th.lastChild:nth-child(2) {
        padding-left: 18px;
      }
      .wy-table-list.targets .wy-table-main thead {
        .wy-sub-header th.lastChild {
          border-right: 0px solid #fff;
        }
        // width: calc(100% - 1478px);
        width: calc(100vw - 411px);
        border-right: 1px solid #CAD2DA;
        border-bottom: 1px solid #CAD2DA;
        th {
          background-color: transparent;
        }
      }
      .wy-table-list.targets .wy-table-main thead tr {
        border-right: 0px solid #CAD2DA;
        border-bottom: 0px;
        background-color: #FFF;
        width: calc( 100vw - 411px);
      }
      .wy-table-list .wy-table-main tbody{
        tr {
          width: calc(100% - 2px);
          border-right: 0px solid #CAD2DA;
        }
      }
      .wy-table-list .wy-table-fixed tbody {
        max-height: unset !important;
        // max-height: calc( 100vh - 570px);
      }
      .wy-table-list.targets .wy-table-main tbody {
        // width: calc(100% - 1479px);
        width: calc(100vw - 412px);
        border-right: 1px solid #CAD2DA;
        border-left: 1px solid #CAD2DA;
        border-bottom: 1px solid #CAD2DA;
      }
    }
    #pane-responsePerformance {
      .wy-table-wrapper {
        width: calc(100%) !important;
        // height: calc(100vh - 514px) !important;
        // border-right: 1px solid #CAD2DA;
        // border-bottom: 1px solid #cad2da;
      }
      .wy-table-list.targets .wy-table-main thead {
        width: calc(100% - 0px);
      }
      .wy-table-list.targets .wy-table-main tbody {
        border-right: 0px;
        width: calc(100% - 4px);
        // border-right: 1px solid #CAD2DA;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #CAD2DA;
        // border-bottom: 1px solid #CAD2DA;
      }
      .wy-table-main thead tr {
        width: calc( 100vw - 687px);
        border-right: 1px solid #CAD2DA;
        border-bottom: 0px;
      }
      .wy-table-list.targets .wy-table-main tbody {
        // width: calc(100% - 1px);
      }
    }
    #pane-nluIntentPerformance {
      .wy-table-wrapper {
        width: calc(100%) !important;
        // height: calc(100vh - 514px) !important;
        // border-right: 1px solid #CAD2DA;
        // border-bottom: 1px solid #cad2da;
      }
      .wy-table-list.targets .wy-table-main thead {
        width: calc(100% - 0px);
      }
      .wy-table-main thead tr {
        width: calc( 100vw - 687px);
        border-right: 1px solid #CAD2DA;
        border-bottom: 0px;
      }

      .wy-table-list.targets .wy-table-main tbody {
        border-right: 0px;
        width: calc(100% - 4px);
        // border-right: 1px solid #CAD2DA;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #CAD2DA;
        // border-bottom: 1px solid #CAD2DA;
      }
      .wy-table-list.targets .wy-table-main tbody {
        // width: calc(100% - 1px);
      }
    }
    .el-tabs__item.is-active {
      background-color: transparent !important;
      border-bottom: 2px solid #106FBC;
    }
    .search-section {
      padding: 20px 0px;
      display: flex;
      .keyword-input {
        display: flex;
        width: 304px;
        margin-right: auto;
        input {
          border-width: 1px !important;
          height: 30px;
          font-size: 15px;
          padding-left: 15px;
          padding-right: 30px;
          padding-bottom: 2px;
          border-radius: 5px;
          width: 288px;
        }
        .fas.fa-times-circle {
          cursor: pointer;
          position: relative;
          top: 7px;
          left: -25px;
        }
      }
    }
    .btn-section {
      display: flex;
      // width: 425px;
      .clear-all-btn {
        font-size: 12px;
        width: 105px;
        line-height: 2.5;
        color: #106FBC;
        cursor: pointer;
      }
      .reset-all-btn {
        font-size: 12px;
        width: 150px;
        text-align: right;
        line-height: 2.5;
        color: #106FBC;
        cursor: pointer;
      }
    }
    .btn-section.disabled {
      pointer-events: none;
      opacity: 0.4;
    }
    
    .el-tabs__header {
      margin: 0px;
    }
    .el-tabs__content {
      padding-top: 0px !important;
      height: 100%;
      .wy-table-list .wy-table-wrapper {
        overflow: hidden;
        .wy-table-main {
          // height: calc(100vh - 492px);
          // height: calc(100vh - 512px);
          tbody {
            height: 100%;
            // max-height: calc( 100vh - 550px);
            max-height: calc( 100vh - 554px);
            border-bottom: 0px solid #eee;
          }
        }
      }
    }
    .title-btns-section {
      display: inline-flex;
      width: 100%;
      .title {
        line-height: 2;
        font-size: 15px;
        font-weight: 700;
      }
      .update-btns {
        display: inline-flex;
        margin-left: auto;
      }
      .update-cancel-btn {
        color: #202223 !important;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-weight: 400;
        padding: 8px 16px 8px 16px;
        display: flex;
        border-radius: 5px;
        height: fit-content;
        width: fit-content;
        border: 1px solid #CAD2DA;
        cursor: pointer;
        background: white;
        margin-right: 15px;
        align-items: center;
        justify-content: center;
        &:hover{
          background: #F4F6F8;
        }
      }
      .update-save-btn {
        width: fit-content;
        height: fit-content;
        padding: 8px 16px 8px 16px;
        font-size: 15px;
        cursor: pointer;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color) !important;
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        border-radius: 5px;
        // margin-right: 15px;
        align-items: center;
        justify-content: center;
      }
      .update-save-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .update-save-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled {
        background: var(--site-button-primary-btn-disabled-background-primary-color);
        cursor: not-allowed;
      }
      .update-save-btn.disabled:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled:active {
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
      }
      .update-save-btn.disabled:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .intent-action-dropdown-save-btn:disabled{
        background: #C0C4CC;
        cursor: not-allowed;
      }
    }

    #tab-journeyPerformance:hover {
      color: #C0C4CC !important;
    }
    .el-loading-mask {
      height: calc(100vh - 200px);
    }
    .wy-page-nodata-with-available-date-range {
      margin-top: 0%;
    }

    .no-data-section {
      border: 1px solid #cad2da !important;
      .wy-table-main {
        border-right: 0px solid #CAD2DA !important;
        border-bottom: 1px solid #cad2da !important;
        thead {
          border: 0px solid #CAD2DA !important;
          border-bottom: 1px solid #CAD2DA !important;
          tr.wy-sub-header > th:first-child {
            border-left: 1px solid transparent;
          }
        }
        thead .wy-sub-header {
          th:first-child {
            span {
              padding-left: 12px;
            }
          }
        }
        tbody {
          overflow-y: hidden;
          border-right: 0px solid #CAD2DA !important;
          border-bottom: 0px solid #eee !important;
          border-left: 0px solid #CAD2DA !important;
        }
      }
    }
  }
</style>